/* eslint-disable no-unused-vars */
import React from "react";
import { Card } from "antd";
import "./index.scss";

const Exceptions = () => {
  return (
    <Card className="exceptions-card">
      <div className="exceptions-header">
        <h3 className="card-title">Exceptions</h3>
        <span className="coming-soon-badge">Coming Soon</span>
      </div>
      <div className="exceptions-skeleton">
        {[90, 70, 55, 35].map((width, i) => (
          <div key={i} className="skeleton-row">
            <div className="skeleton-label" />
            <div className="skeleton-tag" style={{ width: `${width * 0.4}%` }} />
            <div className="skeleton-count" />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default Exceptions;
